import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../shared.service';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { ProjectRiskRating } from 'src/app/core/models/ProjectRiskRating';

@Component({
  standalone: false,
  selector: 'fdb-project-risk-rating',
  templateUrl: './project-risk-rating.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./project-risk-rating.component.scss']
})
export class ProjectRiskRatingComponent {
  public UIControlTyp = UIControlTyp;
  /** Hiermit können Sie den UIControlTyp entscheiden => Default DropDownList */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  // tslint:disable-next-line: no-input-rename
  @Input('values')
  get values() {
    const val = this.uiController === UIControlTyp.MultiSelectList ?
      this.ProjectRiskRatings.map(unit => Number(unit.id)) : Number(this.ProjectRiskRating.id);
    return val;
  }
  set values(val: number | number[]) {
    if (this.uiController === UIControlTyp.MultiSelectList) {
      this.ProjectRiskRatings = (val as number[]).map(id => this.getObjectFromList(id));
    } else {
      this.ProjectRiskRating = this.getObjectFromList(val as number);
    }
  }
  @Output() valuesChange = new EventEmitter();

  /** Enthält die ausgewählten Werte bei UIControlTyp.MultiSelectList */
  public ProjectRiskRating: ProjectRiskRating;
  /** Enthält die ausgewählten Wert bei UIControlTyp.DropDownList */
  public ProjectRiskRatings: ProjectRiskRating[] = [];
  /** Enthält die Werte die angezeigt werden dürfen */
  public ProjectRiskRatingList: ProjectRiskRating[] = [];
  /** Enthält die Originalliste mit allen Werten */
  public OriginalValues: ProjectRiskRating[] = [];

  constructor(private modulService: SharedService) { this.initProjectRiskRatings(); }

  initProjectRiskRatings() {
    this.modulService.getProjectRiskRatings()
      .subscribe(apiResult => {
        if (!apiResult.isSuccessful) {
          this.modulService.showNotification(apiResult.message, 'error');
        }
        if (apiResult.payload) {
          this.OriginalValues = apiResult.payload;
          this.ProjectRiskRatingList = this.OriginalValues.filter(s => s.isActive === true);
          if (this.uiController === UIControlTyp.DropDownList) {
            this.ProjectRiskRatingList.unshift(new ProjectRiskRating().getEmptyModel());
          }
          if (this.uiController === UIControlTyp.MultiSelectList) {
            this.getRefreshSelectedValue();
          }
        }
      });
  }
  filterProjectRisk(value: string) {
    this.ProjectRiskRatingList = this.OriginalValues
      .filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.isActive === true);
  }

  valueChanged(): void {
    this.valuesChange.emit(this.values);
  }

  getObjectFromList(id: number): ProjectRiskRating {
    if (id === 0) {
      return new ProjectRiskRating().getEmptyModel();
    }
    const found = this.OriginalValues.find(unit => unit.id === id);
    const result = found ? found : new ProjectRiskRating().setId(id);
    return result;
  }
  getName() {
    const found = this.getObjectFromList(Number(this.ProjectRiskRating.id));
    return found ? found.name : '';
  }

  getRefreshSelectedValue() {
    this.ProjectRiskRatings = this.ProjectRiskRatings.map(x => this.OriginalValues.find(y => y.id === x.id));
  }
}
